module.exports = __webpack_public_path__ + "media/bgm.20285e37.mp3";